import { annotations } from '@esentai/core/features/productCategory/serializer';

import { createPageSerializer } from '@/serializers';

const serializer = createPageSerializer({
  ...annotations,
});

export default serializer;
